__webpack_require__.p = "/telescience/";